<template>
      <div style="min-height: calc(100vh - 110px); background: linear-gradient(rgb(250, 250, 250), rgb(246, 246, 246)); padding-left: 15px; padding-right: 15px;">
            <div class="row">
                  <div class="col-2">
                      <inbox-menu />
                  </div>
                  <div class="col" style="min-height: calc(100vh - 110px); background: white;">
                      <router-view></router-view>
                  </div>
            </div>
      </div>
</template>

<script>
    import MessageListView from "./MessageListView";
    import InboxMenu from "./InboxMenu";

    export default {
        components: {
            MessageListView,
            InboxMenu
        },
        mounted() {
            this.$store.dispatch('inbox/messageBoxes/load')
        },
    }
</script>

<style lang="scss" scoped>
    //
</style>